"use client";

// Flag-off rollback is the real static entry, not wrappers in legacy mode.
export { AppShell } from "./AppShell";
